(ns app.totp.validation
  "Shared TOTP validation logic for both Clojure and ClojureScript.
   Pure functions — no OTP generation or platform-specific dependencies."
  (:require [clojure.string :as str]))

(def secret-key-length
  "Expected length of a base32-encoded TOTP secret key."
  32)

(def totp-period
  "TOTP time step in seconds (RFC 6238 standard)."
  30)

(defn valid-base32?
  "Returns true if the string contains only valid base32 characters (A-Z, 2-7)."
  [s]
  (boolean (re-matches #"[A-Za-z2-7]+" s)))

(defn valid-secret-format?
  "Returns true if the secret has the correct length and valid base32 characters.
   Does not verify that the secret can actually generate an OTP code."
  [secret]
  (and (string? secret)
       (= (count secret) secret-key-length)
       (valid-base32? secret)))

(defn clean-secret
  "Strips spaces from a raw TOTP secret input."
  [raw]
  (str/replace raw " " ""))
